var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{on:{"page:beforein":_vm.beforein}},[_c('navbar',{attrs:{"text":`${_vm.$t('Utilities_Title')} > ${_vm.$t('Vademecum_Title')}`}}),_vm._v(" "),_c('phytosanitaryProducts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }